import React from "react";
import { AmplifyLogo } from "@/components/AmplifyLogo";
import { Home, Plus } from "lucide-react";

export function DashboardHeader({ onBack, onNewQuote }) {
  return (
    <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
      <div className="max-w-[1600px] mx-auto px-6 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <AmplifyLogo size={32} />
          <span className="text-xl font-semibold font-['Outfit'] text-slate-900 tracking-tight">Amplify HR</span>
          <span className="text-xs font-medium text-slate-400 border border-slate-200 rounded-full px-2.5 py-0.5 ml-1">Dashboard</span>
        </div>
        
        <div className="flex items-center gap-3">
          <button
            data-testid="back-to-engine-btn"
            onClick={onBack}
            className="flex items-center gap-1.5 px-4 py-2 bg-white border border-slate-200 text-slate-700 rounded-lg text-sm font-medium hover:bg-slate-50 transition-all"
          >
            <Home size={15} />
            Back to Engine
          </button>
          <button
            data-testid="new-quote-btn"
            onClick={onNewQuote}
            className="flex items-center gap-1.5 px-4 py-2 bg-[#3c68ff] text-white rounded-lg text-sm font-medium hover:bg-[#2b4bca] transition-all shadow-sm"
          >
            <Plus size={15} />
            New Quote
          </button>
        </div>
      </div>
    </header>
  );
}
